/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AssignRequest {
  org_id: string;
  plan_id: string;
  /**
     * @minimum 1
     * @maximum 10000
     */
  seat_count: number;
  /** @pattern ^(monthly|annual)$ */
  billing_cadence: string;
  expires_at?: string | null;
  /** @maxLength 320 */
  admin_email: string;
  /** @maxLength 255 */
  admin_user_id: string;
  notes?: string | null;
}
